import type { ExpandedFoodRow, MealMeta } from './nutritionalAnalysisTypes';

export const fallbackMealMeta: MealMeta[] = [
  { name: 'Pre-Breakfast', time: '06:00 AM', sortOrder: 1, apiMealName: 'Pre-Breakfast' },
  { name: 'Breakfast', time: '07:35 AM', sortOrder: 2, apiMealName: 'Breakfast' },
  { name: 'Snack 1', time: '10:30 AM', sortOrder: 3, apiMealName: 'Snack 1' },
  { name: 'Lunch', time: '01:00 PM', sortOrder: 4, apiMealName: 'Lunch' },
  { name: 'Snack 2', time: '05:00 PM', sortOrder: 5, apiMealName: 'Snack 2' },
  { name: 'Dinner', time: '08:00 PM', sortOrder: 6, apiMealName: 'Dinner' },
];

export const fallbackRowsByMeal: Record<string, ExpandedFoodRow[]> = {
  'Pre-Breakfast': [{ item: 'Apple Cider Vinegar Water', qty: 2, unit: 'tbsp', serving: 'standard', kcal: '3', protein: '0', carbs: '0.1', fat: '0' }],
  Breakfast: [
    { item: 'Carrot Pesarattu', qty: 2, unit: 'piece', serving: 'standard', kcal: '3', protein: '0', carbs: '0.1', fat: '0' },
    { item: 'Sesame Seeds', qty: 2, unit: 'tbsp', serving: 'standard', kcal: '3', protein: '0', carbs: '0.1', fat: '0' },
  ],
  'Snack 1': [{ item: 'Roasted Chickpeas', qty: 1, unit: 'cup', serving: 'standard', kcal: '85', protein: '7.0', carbs: '25.0', fat: '8.5' }],
  Lunch: [{ item: 'Brown Rice Bowl', qty: 1, unit: 'bowl', serving: 'standard', kcal: '205', protein: '7.0', carbs: '25.0', fat: '8.5' }],
  'Snack 2': [{ item: 'Fruit and Nuts', qty: 1, unit: 'plate', serving: 'standard', kcal: '116', protein: '7.0', carbs: '25.0', fat: '8.5' }],
  Dinner: [{ item: 'Paneer Stir Fry', qty: 1, unit: 'plate', serving: 'standard', kcal: '340', protein: '7.0', carbs: '25.0', fat: '8.5' }],
};

export const nutritionTableColumns = '2fr repeat(7, minmax(0, 1fr))';
/** Leading checkbox column for picking among recipe/ingredient alternatives (generic meal plans). */
export const nutritionTableColumnsWithCheckbox = '44px 2fr repeat(7, minmax(0, 1fr))';
/** Public template view (read-only): no ACTIONS column; more room for food name and unit. */
export const nutritionTableColumnsReadOnlyPublic = 'minmax(160px, 2.5fr) 80px minmax(132px, 1.55fr) 76px repeat(3, minmax(52px, 1fr))';
export const nutritionTableColumnsWithCheckboxReadOnlyPublic =
  '44px minmax(160px, 2.3fr) 80px minmax(132px, 1.55fr) 76px repeat(3, minmax(52px, 1fr))';
export const defaultUnitOptions = ['tbsp', 'piece', 'cup', 'bowl', 'plate'];
export const defaultServingOptions = ['standard', 'small', 'large'];
export const defaultMacroTargets = { calories: 2000, protein: 75, carbs: 200, fat: 85 };
export const defaultAddIngredientServingId = 'serving';
export const defaultAddRecipeServingId = 'serving';
export const defaultAIDraftIngredientServingId = 'g';
/** Wait this long after the last qty edit before committing and calling the API. */
export const quantitySyncDelayMs = 3000;

export const defaultMealTimesByName: Record<string, string> = {
  'pre breakfast': '06:00 AM',
  breakfast: '07:35 AM',
  'snack 1': '10:30 AM',
  lunch: '01:00 PM',
  'snack 2': '05:00 PM',
  dinner: '08:00 PM',
};

export const MANUAL_ANALYSIS_MEAL_COLORS = ['#f59e0b', '#2ec3b6', '#3f9fee', '#f59e0b', '#2ec3b6', '#3f9fee'];

/** Reference date for parsing meal times without timezone drift. */
export const MEAL_TIME_REF_DATE = new Date(2000, 0, 1);
